const PARAM = Object.freeze({
    rightsholderId: ':rightsholderId',
    workId: ':workId',
    typeWork: ':typeWork',
    userId: ':userId',
    activatingCode: ':activatingCode',
    recordingId: ':recordingId',
    contactId: ':contactId',
    submissionId: ':submissionId',
    recordingGroupCategory: ':recordingGroupCategory',
    overclaimHeaderId: ':overclaimHeaderId',
    tabName: ':tabName',
    songwriterId: ':songwriterId',
    cowriterIpId: ':cowriterIpId',
    transferId: ':transferId',
    suggestionId: ':suggestionId',
    workMergeRequestId: ':workMergeRequestId',
})
const SEARCH_PARAM = Object.freeze({
    payee: 'payee',
    period: 'period',
    matchHistoryFilter: 'matchHistoryFilter',
})
export { SEARCH_PARAM, PARAM }
